<template>
  <div class="wrapper">
    <div class="search-bg wrapper center">
      <div class="search-box center-wrapper">
        <el-col :span="11">
          <div
            class="left-intro"
          > 
          <img src="../assets/img/left-star.png" alt="" class="left-star">
            <img src="../assets/img/smlogo.png" alt="" class="first-logo">
            <p>查证书&nbsp;&nbsp;学知识</p>
            <div class="sm-star">
              <span>就上甄宝阁</span>
              <img src="../assets/img/right-star.png" alt="" class="right-star">
            </div>
            <div class="multi-type">
                <img src="../assets/img/multi-one.svg" alt="">
                <img src="../assets/img/multi-two.svg" alt="">
                <img src="../assets/img/multi-three.svg" alt="">
                <img src="../assets/img/multi-four.svg" alt="">
                <img src="../assets/img/multi-five.svg" alt="">
            </div>  
          </div>
        </el-col>
        <el-col :span="13">
          <el-form
            ref="form"
            :model="form"
            label-width="70px"
          >
            <el-form-item label="">
              <el-input
                placeholder="请输入证书编号"
                prefix-icon="el-icon-search"
                v-model="form.number"
              >
              </el-input>
            </el-form-item>
            <el-form-item label="">
              <el-input
                placeholder="请输入查询码或重量"
                prefix-icon="el-icon-search"
                v-model="form.searchCode"
              >
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button @click="onSubmit">查询</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </div>
    </div>
    <div class="message">
      <Trade :noHeader='false' />
    </div>
    <div style="background: rgb(240, 240, 240)">
    <aboutUsFooter/>
    </div>
  </div>
</template>

<script>
import Trade from "./Trade.vue"
import aboutUsFooter from '@/components/aboutUsFooter'
export default {
  name: "login",
  components: {
    Trade,
    aboutUsFooter
  },
  data() {
    return {
      form: {
        site: "",
        number: "",
        searchCode: ""
      },
      options: [
        {
          value: "选项1",
          label: "黄金糕"
        },
        {
          value: "选项2",
          label: "双皮奶"
        },
        {
          value: "选项3",
          label: "蚵仔煎"
        },
        {
          value: "选项4",
          label: "龙须面"
        },
        {
          value: "选项5",
          label: "北京烤鸭"
        }
      ]
    };
  },
  methods: {
    onSubmit() {
      
    }
  }
};
</script>
<style lang="scss" scoped>
.left-intro {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  position: relative;
   .first-logo {
      width: 150px;
      height: 150px;
     object-fit: none;
   }
   p {
      padding-top: 10px;
      text-shadow: 0px 2.34px 0px rgba(255, 255, 255, 0.85);
      font-size: 50px;
      font-weight: 700;
   }
   .sm-star {
      display: inline-flex;
      justify-content: center;
      align-items: center;
      position: relative;
      .right-star {
        position: absolute;
        left: 255px;
      }
   }
   span {
    display: inline-block;
    padding: 20px 0;
    letter-spacing: 12.76px;
    font-size: 21.26px;
    font-weight: 400;
   }
   .multi-type {
      width: 80%;
      display: flex;
      justify-content: center;
      align-items: center;
   }
   .left-star {
     position: absolute;
     top:20px;
     left: 20px;
   }
}
.search-bg {
  height: 620px;
  background: url('../assets/img/bigBg.png') no-repeat;
  .search-box {
    display: flex;
    background: #ffffff;
    height: 480px;
    box-shadow: 0px 4px 50px rgba(122, 145, 158, 0.25);
    border-radius: 14px;
    padding: 50px 90px 40px 70px;
    .search-left {
      width: 100%;
      height: 100%;
      background: #2093ca;
    }
  }
  .el-select,
  .el-button {
    width: 100%;
  }
  .el-button {
    background: #2093ca;
    color: #ffffff;
    font-size: 20px;
    letter-spacing: 4px;
  }
  .tip-box {
    height: 80%;
    margin-left: 70px;
    line-height: 20px;
    .tip {
      color: rgba(128, 128, 128, 1);
      font-size: 14px;
    }
  }
}
.search-bg ::v-deep .el-input__inner,
.el-button {
  height: 54px !important;
  border: 1px solid #2093ca;
}
.message {
  padding-top: 50px;
  height: auto;
  width: 100%;
  padding-bottom: 50px;
  background: rgb(240, 240, 240);
}
</style>
